module.exports = __webpack_public_path__ + "img/generic-catalog.99bdaecf.svg";